

const BASE_URL = process.env.REACT_APP_API_URL || '/api';

export const getDashboardSummary = async () => {
  try {
    const response = await fetch(`${BASE_URL}/dashboard/summary`, {
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
    });
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    return await response.json();
  } catch (error) {
    console.error('Error fetching dashboard summary:', error);
    throw error;
  }
};

export const getDashboardMetrics = async () => {
  try {
    const response = await fetch(`${BASE_URL}/dashboard/metrics`, {
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
    });
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    return await response.json();
  } catch (error) {
    console.error('Error fetching dashboard metrics:', error);
    throw error;
  }
};

export const getDashboardActivity = async (limit = 10) => {
  try {
    const response = await fetch(`${BASE_URL}/dashboard/activity?limit=${limit}`, {
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
    });
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    return await response.json();
  } catch (error) {
    console.error('Error fetching dashboard activity:', error);
    throw error;
  }
};

export const getDashboardActionItems = async () => {
  try {
    const response = await fetch(`${BASE_URL}/dashboard/action-items`, {
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
    });
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    return await response.json();
  } catch (error) {
    console.error('Error fetching dashboard action items:', error);
    throw error;
  }
};

export const getDashboardStats = async () => {
  try {
    const response = await fetch(`${BASE_URL}/dashboard/stats`, {
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
    });
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    return await response.json();
  } catch (error) {
    console.error('Error fetching dashboard stats:', error);
    throw error;
  }
};

export const getDashboardCashFlow = async () => {
  try {
    const response = await fetch(`${BASE_URL}/dashboard/cash-flow`, {
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
    });
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    return await response.json();
  } catch (error) {
    console.error('Error fetching dashboard cash flow:', error);
    throw error;
  }
};
